import { StyleSheet,Dimensions } from 'react-native';

export default StyleSheet.create({
    container: {
      flex: 1,
      flexDirection: "column"
    },
    imageBackground: {
      flex: 1,
      resizeMode: "cover",
      justifyContent: "center",
      paddingBottom:15,

    },
    imatge: {
      height: 150,
      width: 150,
      justifyContent: "center",
      alignSelf:'center',
      paddingBottom:10
    },
    text: {
      fontFamily: 'OpenSans',
      color: "black",
      fontSize: 23,
      textAlign: "justify",
      justifyContent:'center',
      alignContent:'center',
    },
    caixaOut:{
      backgroundColor:'rgba(116, 81, 110, 0.8)',
      marginHorizontal:'10%', 
      borderRadius:10,
      flex: 1,
    },
    titol: {
      fontFamily: 'Lobster',
      fontSize: 30,
      textAlign: "center",
      marginBottom: 1,
      borderBottomColor:'white',
      borderBottomWidth:1,
      paddingBottom:8,
      width:'90%',
      alignSelf:'center'
    },
    caixa:{
      flex: 1,
      marginHorizontal:10,
      marginVertical:10,
    },
    caixaBorderContenidor:{
      borderWidth: 3,
      borderRadius:10,
    },
    backgroundImatges: {
      height: "100%",
      resizeMode: "cover",
      justifyContent: "center",
  },
  touchableIcon:{
      flex: 1,
      width:"50%",
      height:"100%",
      alignSelf:'center'
    },
  menuIcon:
  {
      width:'55%',
      height: "90%",
      alignSelf:'center',
      resizeMode:'contain',
  },
  textItinerari:
  {
      alignSelf:'center',
      fontSize:'2vh',
      fontWeight:'bold',
      color: "#3d342a",
      marginTop:'-4%',
  },
  titol : {
      fontSize: "4vh",
      color: "#009499",
      textAlign: "center",
      justifyContent: "center",
      alignItems: "center",
      fontFamily: "Leckerli One",
      textShadow: "-0.5vh -0.5vh 0.5vh #f2eed7, 0.5vh -0.5vh 0.5vh #f2eed7, -0.5vh 0.5vh 0.5vh #f2eed7, 0.5vh 0.5vh 0.5vh #f2eed7"
  },
  descriptionContainer: {
      flex:40,
      width: "80%",
      textAlign: "center",
      alignSelf: 'center',
      fontFamily: 'OpenSans',
      fontSize: "2.5vh",
      // color: "#3d342a"
  },
  imageItinerari: {
    width:'95%',
    height:'100%',
    alignSelf:'center',
    resizeMode:'contain',
  },
  subtitol: {
      fontSize: 20,
      textAlign: "center",
      fontWeight: "500",
      width: '100%',
      alignSelf: 'center',
      color: "#3d342a",
      paddingBottom: 4,
  },
  itinerariContainer: {
    paddingTop: 5,
    paddingBottom: 5,
    width: "100%",
    textAlign: "center",
    alignSelf: 'center',
    marginTop: 7,
    marginBottom: 7,
    marginLeft: 7,
    marginRight: 7,
    backgroundColor: "#715f4d",
    borderRadius: 10,
},
});